import React from 'react'

import { Text } from '@wartek-id/text-v1'
import { Spinner } from '@wartek-id/spinner'
import { Separator } from '@wartek-id/separator'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import { ButtonPelaksanaanAppealRollback } from 'app/KinerjaPSPegawaiPage/components/ButtonPelaksanaanAppealRollback'
import { sanitizeAndFormatHTML } from 'app/KinerjaPSPegawaiPage/utils/html'
import useToggleSdkContext from 'utils/useToogleSdk'

import type {
  TPraktikKinerjaDiskusiPersiapanFormValue,
  TPraktikKinerjaPerencanaanSummary,
} from 'types/kinerja-ps-pegawai'

type TPraktikKinerjaDiskusiPersiapanViewProps = {
  formValues: TPraktikKinerjaDiskusiPersiapanFormValue
  perencanaanSummary: TPraktikKinerjaPerencanaanSummary

  isLoading?: boolean
  isFetched?: boolean
}

export default function PSPelaksanaanDiskusiPersiapanView({
  formValues,
  perencanaanSummary,
  isLoading = true,
  isFetched = false,
}: TPraktikKinerjaDiskusiPersiapanViewProps) {
  const toggle = useToggleSdkContext()
  const appealRollbackEnabled =
    toggle?.['kinerja-ps-pegawai-appeal-rollback-enabled'] || false

  return (
    <div className="flex gap-6">
      {isLoading && (
        <div
          data-testid="loading-spinner-diskusi-persiapan"
          className="flex justify-center w-full p-6"
        >
          <Spinner />
        </div>
      )}

      {isFetched && (
        <SimpleCard
          className="!rounded mx-auto"
          style={{
            width: '963px',
          }}
        >
          <div className="flex items-center p-6 border-b rounded-t bg-surface-selected-default border-b-surface-subdued">
            <Text variant="heading-lg">
              Berikut isi catatan yang sudah dikumpulkan:
            </Text>
          </div>
          <div className="flex flex-col gap-6 p-6">
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-x-3">
                <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-blue-70">
                  <Text color="inverse" variant="body-sm-bold">
                    1
                  </Text>
                </div>
                <Text variant="action">
                  Tiga tantangan yang pernah atau berpotensi Anda temukan saat
                  pendampingan:
                </Text>
              </div>
              <div className="pl-9">
                <Text
                  variant="body"
                  color="subdued"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeAndFormatHTML(formValues.tantangan),
                  }}
                />
              </div>
            </div>

            <Separator orientation="horizontal" />

            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-x-3">
                <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-blue-70">
                  <Text color="inverse" variant="body-sm-bold">
                    2
                  </Text>
                </div>
                <Text variant="action">
                  Satu isu yang penting untuk menjadi fokus pendampingan:
                </Text>
              </div>
              <div className="pl-9">
                <Text
                  variant="body"
                  color="subdued"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeAndFormatHTML(formValues.isu),
                  }}
                />
              </div>
            </div>

            <Separator orientation="horizontal" />

            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-x-3">
                <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-blue-70">
                  <Text color="inverse" variant="body-sm-bold">
                    3
                  </Text>
                </div>
                <Text variant="action">
                  Satdik untuk menjadi fokus pendampingan:
                </Text>
              </div>
              <div className="pl-9">
                <Text
                  variant="body"
                  color="subdued"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeAndFormatHTML(
                      perencanaanSummary.satuanPendidikan.find(
                        (satdik) =>
                          satdik.npsn === formValues.npsn_satdik_pendamping
                      )?.satuanPendidikan ?? ''
                    ),
                  }}
                />
              </div>
            </div>

            <Separator orientation="horizontal" />

            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-x-3">
                <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-blue-70">
                  <Text color="inverse" variant="body-sm-bold">
                    4
                  </Text>
                </div>
                <Text variant="action">
                  Strategi Anda dalam melakukan pendampingan di satdik tersebut:
                </Text>
              </div>
              <div className="pl-9">
                <Text
                  variant="body"
                  color="subdued"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeAndFormatHTML(formValues.strategi),
                  }}
                />
              </div>
            </div>

            {appealRollbackEnabled && (
              <>
                <Separator orientation="horizontal" />
                <div className="flex justify-end">
                  <ButtonPelaksanaanAppealRollback formName="diskusi_persiapan" />
                </div>
              </>
            )}
          </div>
        </SimpleCard>
      )}
    </div>
  )
}
